import TabContent from '../../hierarchyAssignmentsPanelTab/components/TabContent'
import messageResource from '../../../../messageResource'
import {HierarchyLevels} from 'constants'
import {ALL_TABS_EMPTY_KEY} from '../../hierarchyAssignmentsPanelTab/constants'

export default class WorkAssignmentPanelTabContent extends TabContent {
    tabHeaderTitle() {
        const tab = this.state.openTab
        switch (tab) {
            case HierarchyLevels.TASK:
                return messageResource.getMessage("work_assignments.panel.tasks.title", [], true)
            case HierarchyLevels.PROJECT:
                return messageResource.getMessage("work_assignments.panel.projects.title", [], true)
            case HierarchyLevels.CUSTOMER:
                return messageResource.getMessage("work_assignments.panel.customer.title", [], true)
        }
        return ""
    }

    getRevokeConfirmationText() {
        const tab = this.state.openTab
        let hierarchyLevelName = ""
        let entitiesList = []

        switch (tab) {
            case HierarchyLevels.TASK:
                hierarchyLevelName = messageResource.getMessage('common.tasks')
                entitiesList = this.state.taskEntities
                break
            case HierarchyLevels.PROJECT:
                hierarchyLevelName = messageResource.getMessage('common.projects')
                entitiesList = this.state.projectEntities
                break
            case HierarchyLevels.CUSTOMER:
                hierarchyLevelName = messageResource.getMessage('common.customers')
                entitiesList = this.state.customerEntities
                break
        }
        let resultMessage = messageResource.getMessage('work_assignments.panel.revoke_message', [hierarchyLevelName, this.state.userFirstName])

        const hasAnyManageableEntity = entitiesList.some(entity => !entity.revokeEnabled)
        if (hasAnyManageableEntity)
            resultMessage += '\n' + messageResource.getMessage('work_assignments.panel.revoke_message_note', [hierarchyLevelName])

        return resultMessage
    }

    _setEmptyListTitles() {
        this.emptyList.setState({
            titlesMap: {
                [HierarchyLevels.CUSTOMER]:  messageResource.getMessage("work_assignments.empty_customer_list", [this.state.userFirstName]),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("work_assignments.empty_project_list", [this.state.userFirstName]),
                [HierarchyLevels.TASK]: messageResource.getMessage("work_assignments.empty_task_list", [this.state.userFirstName]),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("work_assignments.empty_list.no_work_from_my_scope", [this.state.userFirstName]),
            },
            noSelectedTitlesMap: {
                [HierarchyLevels.CUSTOMER]:  messageResource.getMessage("management_assignment.empty_customer_list", [this.state.userFirstName]),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("management_assignment.no_selected_projects"),
                [HierarchyLevels.TASK]: messageResource.getMessage("management_assignment.no_selected_tasks"),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("work_assignments.empty_list.assign_cpt"),
            },
            subtitlesAssignItemsMap: {
                [HierarchyLevels.CUSTOMER]: messageResource.getMessage("work_assignments.empty_customer_list.assign_customers", [this.state.userFirstName]),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("work_assignments.empty_project_list.assign_projects", [this.state.userFirstName]),
                [HierarchyLevels.TASK]: messageResource.getMessage("work_assignments.empty_task_list.assign_tasks", [this.state.userFirstName]),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("work_assignments.empty_list.assign_cpt"),
            },
            subtitlesAssignMoreItemsMap: {
                [HierarchyLevels.CUSTOMER]: messageResource.getMessage("work_assignments.empty_customer_list.assign_more_customers", [this.state.userFirstName]),
                [HierarchyLevels.PROJECT]: messageResource.getMessage("work_assignments.empty_project_list.assign_more_projects", [this.state.userFirstName]),
                [HierarchyLevels.TASK]: messageResource.getMessage("work_assignments.empty_task_list.assign_more_tasks", [this.state.userFirstName]),
                [ALL_TABS_EMPTY_KEY]: messageResource.getMessage("work_assignments.empty_list.assign_cpt"),
            }
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/WorkAssignmentPanelTabContent.js